import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
    SalesMasterCloneAndCreateRequestDTO,
    SalesMasterCreateRequestDTO,
    SalesMasterDeleteRequestDTO,
    SalesMasterDTO,
    SalesMasterList,
    SalesMasterReadByBilledCompanyIdRequestDTO,
    SalesMasterReadByIdRequestDTO,
    SalesMasterReadByMasterIdRequestDTO,
    SalesMasterReadByOrderIdRequestDTO,
    SalesMasterReadByProjectIdRequestDTO,
    SalesMasterSearchByInvoiceNoRequestDTO,
    SalesMasterUpdateRequestDTO
} from './sales.inteface';
import {
    SalesInvoiceOtherCharges_create,
    SalesInvoiceOtherCharges_delete,
    SalesInvoiceOtherCharges_readById,
    SalesInvoiceOtherCharges_readByInvoiceId,
    SalesInvoiceOtherCharges_update,
    SalesMaster_CloneAndCreate,
    SalesMaster_Create,
    SalesMaster_Delete,
    SalesMaster_ReadAll,
    SalesMaster_ReadByBilledCompanyId,
    SalesMaster_ReadById,
    SalesMaster_ReadByMasterId,
    SalesMaster_ReadByOrderId,
    SalesMaster_ReadByProjectId,
    SalesMaster_SearchByInvoiceNo,
    SalesMaster_Update,
    TallyExport_ExportTally,
} from 'src/app/GlobalVariables';
import { SalesInvoiceOtherChargesCreateRequestDTO, SalesInvoiceOtherChargesDeleteRequestDTO, SalesInvoiceOtherChargesDTO, SalesInvoiceOtherChargesList, SalesInvoiceOtherChargesReadByIdRequestDTO, SalesInvoiceOtherChargesReadByInvoiceIdRequestDTO, SalesInvoiceOtherChargesUpdateRequestDTO } from './salesinvoiceOthercharges.interface';



@Injectable({
    providedIn: 'root'
})
export class SalesMasterService {

    constructor() { }

    http = inject(HttpClient);

    SalesMaster_Create(data: SalesMasterCreateRequestDTO): Observable<SalesMasterDTO> {
        return this.http.post<SalesMasterDTO>(SalesMaster_Create, data);
    }

    SalesMaster_Update(data: SalesMasterUpdateRequestDTO): Observable<SalesMasterDTO> {
        return this.http.post<SalesMasterDTO>(SalesMaster_Update, data);
    }

    SalesMaster_Delete(data: SalesMasterDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(SalesMaster_Delete, data);
    }

    SalesMaster_ReadById(data: SalesMasterReadByIdRequestDTO): Observable<SalesMasterDTO> {
        return this.http.post<SalesMasterDTO>(SalesMaster_ReadById, data);
    }
    SalesMaster_ReadByMasterId(data: SalesMasterReadByMasterIdRequestDTO): Observable<SalesMasterList> {
        return this.http.post<SalesMasterList>(SalesMaster_ReadByMasterId, data);
    }

    SalesMaster_ReadAll(): Observable<SalesMasterList> {
        return this.http.get<SalesMasterList>(SalesMaster_ReadAll);
    }

    SalesMaster_ReadByOrderId(data: SalesMasterReadByOrderIdRequestDTO): Observable<SalesMasterDTO> {
        return this.http.post<SalesMasterDTO>(SalesMaster_ReadByOrderId, data);
    }
    SalesMaster_SearchByInvoiceNo(data: SalesMasterSearchByInvoiceNoRequestDTO): Observable<SalesMasterList> {
        return this.http.post<SalesMasterList>(SalesMaster_SearchByInvoiceNo, data);
    }

    SalesMaster_ReadByProjectId(data: SalesMasterReadByProjectIdRequestDTO): Observable<SalesMasterList> {
        return this.http.post<SalesMasterList>(SalesMaster_ReadByProjectId, data);
    }
    SalesMaster_ReadByBilledCompanyId(data: SalesMasterReadByBilledCompanyIdRequestDTO): Observable<SalesMasterList> {
        return this.http.post<SalesMasterList>(SalesMaster_ReadByBilledCompanyId, data);
    }

    SalesMaster_CloneAndCreate(data:SalesMasterCloneAndCreateRequestDTO):Observable<SalesMasterDTO>{
        return this.http.post<SalesMasterDTO>(SalesMaster_CloneAndCreate,data)
    }
    //sales invoice
    SalesInvoiceOtherCharges_create(data: SalesInvoiceOtherChargesCreateRequestDTO): Observable<SalesInvoiceOtherChargesDTO> {
        return this.http.post<SalesInvoiceOtherChargesDTO>(SalesInvoiceOtherCharges_create, data);
    }

    SalesInvoiceOtherCharges_update(data: SalesInvoiceOtherChargesUpdateRequestDTO): Observable<SalesInvoiceOtherChargesDTO> {
        return this.http.post<SalesInvoiceOtherChargesDTO>(SalesInvoiceOtherCharges_update, data);
    }

    SalesInvoiceOtherCharges_delete(data: SalesInvoiceOtherChargesDeleteRequestDTO): Observable<void> {
        return this.http.post<void>(SalesInvoiceOtherCharges_delete, data);
    }
    SalesInvoiceOtherCharges_readByInvoiceId(data: SalesInvoiceOtherChargesReadByInvoiceIdRequestDTO): Observable<SalesInvoiceOtherChargesList> {
        return this.http.post<SalesInvoiceOtherChargesList>(SalesInvoiceOtherCharges_readByInvoiceId, data);
    }
    SalesInvoiceOtherCharges_readById(data: SalesInvoiceOtherChargesReadByIdRequestDTO): Observable<SalesInvoiceOtherChargesDTO> {
        return this.http.post<SalesInvoiceOtherChargesDTO>(SalesInvoiceOtherCharges_readById, data);
    }

    SalesMaster_ExportTally(data: {
        tenantId: number;
        tenantBranchId: number;
        fromDate: string;
        toDate: string;
        configId: number;
        documentType: string;
    }): Observable<Blob> {
        return this.http.post(TallyExport_ExportTally, data, { responseType: 'blob' });
    }
}

